export default "__VITE_ASSET__DWIKokNu__"